import { EscrowPartyTypeEnum } from 'src/graphql/schema';
import { OtherEscrowStatusEnum } from 'src/shared/constants';

import type { IClientChangesRequestedQuery } from 'src/graphql/actions/suggestChanges/clientChangesRequested.query';

export const getRequestChangesStatus = (
  currentCompanyRole: EscrowPartyTypeEnum,
  clientChangesRequested: IClientChangesRequestedQuery['clientChangesRequested'],
) => {
  const changes = [
    clientChangesRequested.agreement,
    clientChangesRequested.deposits,
    clientChangesRequested.environment,
  ].filter(Boolean);

  for (const change of changes) {
    if (change?.creator !== currentCompanyRole && change?.status === 'pending')
      return OtherEscrowStatusEnum.ChangesRequestedInReview;

    if (change?.creator !== currentCompanyRole && change?.status === 'accepted')
      return OtherEscrowStatusEnum.ChangesRequestedReceiver;
  }

  return null;
};
